import{Colors as r}from"../enums";export var getColorAsRgba=function(o,t){return void 0===t&&(t=1),r[o].replace("%",t.toString())};